import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { horizontalSpace } from '@doltech/utils/lib/css-style';
import { isEmptySlateNodeValue } from '@doltech/utils/lib/editor';

import { useRootElement } from '../../../slatePlugins/common/hocs/current-element.store';
import { findBellowByType } from '../../../figma/DolEditor/helpers/nodeValue';
import { ResponsiveTypography } from '../../../figma/Typography/v3/ResponsiveTypography';
import { CardQuizExplain } from '../../../figma/CardQuizExplain/CardQuizExplain';
import { QuestionNumberInlineItem } from '../../../figma/QuestionNumberInlineItem/QuestionNumberInlineItem';
import { useProgressListGrammar } from '../../hocs/progress-list-grammar';
import {
  EXERCISE_SHORT_ANSWER_QUESTION,
  SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES,
} from '../types';

const QuestionSubjectContent = styled.div`
  display: block;
  vertical-align: middle;

  ${horizontalSpace(6)}

  .question-text {
    display: inline;
    vertical-align: middle;
  }
`;

const GuideContent = styled.div``;

const Container = styled.div``;

export const ShortAnswerParagraphToggle = (props: RenderElementProps) => {
  const { element, children } = props;
  const isEmpty = isEmptySlateNodeValue(element);

  if (isEmpty) {
    return null;
  }

  switch (element.present) {
    case SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES.QUESTION:
      return <QuestionSubject {...props} />;
    case SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES.EXPLANATION:
      return <Explanation {...props} />;
    case SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES.GUIDE:
      return <GuideParagraph {...props} />;
    default:
      return children;
  }
};

const GuideParagraph = (props: RenderElementProps) => {
  const { element, children, attributes } = props;

  if (!element.visible) {
    return null;
  }

  return (
    <Container className="short-answer-paragraph-toggle guide-paragraph" {...attributes}>
      <GuideContent>
        <ResponsiveTypography.Paragraph variant="semi-bold/16-24" color="neutral180" mb="4px">
          Đề bài
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph variant="regular/16-28" color="neutral180">
          {children}
        </ResponsiveTypography.Paragraph>
      </GuideContent>
    </Container>
  );
};

const QuestionSubject = (props: RenderElementProps) => {
  const { element, children, attributes } = props;
  const root = useRootElement();
  const questions = findBellowByType(root, EXERCISE_SHORT_ANSWER_QUESTION);
  const questionIndex = questions.findIndex((question) =>
    question.children.some((child) => child === element)
  );

  return (
    <Container className="short-answer-paragraph-toggle question-subject" contentEditable={false} {...attributes}>
      <QuestionSubjectContent>
        <QuestionNumberInlineItem order={questionIndex + root.startFrom} />
        {element.visible && (
          <ResponsiveTypography.Text
            className="question-text"
            variant="regular/16-28"
            color="neutral180"
          >
            {children}
          </ResponsiveTypography.Text>
        )}
      </QuestionSubjectContent>
    </Container>
  );
};

const Explanation = (props: RenderElementProps) => {
  const { children, attributes } = props;
  const progressStore = useProgressListGrammar();

  return (
    <Container
      className="short-answer-paragraph-toggle explanation"
      style={{ display: progressStore?.isShowResult ? 'block' : 'none' }}
      contentEditable={false}
      {...attributes}
    >
      <CardQuizExplain
        title="Giải thích chi tiết"
        description={children}
      />
    </Container>
  );
};
